// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    border-collapse: collapse !important;
    border: 1px solid grey !important;
    border-radius: 5px !important;
    margin-top: 10px !important;
}

.table-header-cell {
    color: white !important;
    background-color: #2f3347 !important;
    font-weight: bold !important;
}
.schedules-table-cell {
    width: 11rem; 

}
.table-row-even {
    background-color: #f0f0f0 !important;
    /* Use any desired color for even rows */
}

.table-row-odd {
    background-color: white !important;
    /* Use any desired color for odd rows */
}

.table-cell {
    color: black !important;
}

.table-cell-action {
    color: black !important;
}


.schedules-table-weekly-date-picker-text { 
    display: flex;
    justify-content: center;
}

.schedules-table-no-data-found-text {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.schedules-table-avatar-div {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
    gap: 10px;
}


.schedules-table-full-name-text {
    margin-left: 0.5rem;
    margin-bottom: 1rem;
}

.schedules-table-preferred-div {
    background-color: #b4f8c6;
    padding: 10px 5px 10px 5px;
    border-radius: 7px;
}

.schedules-table-preferred-text {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 13px;
}

.schedules-table-whole-day-text { 
    display: flex;
    justify-content: center;
    font-size: 10px;
}


.schedules-table-unavailable-div {
    background-color: #fffbae;
    padding: 10px 5px 10px 5px;
    border-radius: 7px;
}

.schedules-table-unavailable-text {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 13px;
}

.schedules-table-role-name {
    display: flex;
    justify-content: center;
    font-size: 10px;
}

.schedules-table-date-div {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
    border: 1px solid white;
    border-radius: 7px;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.schedules-table-date-text {
    font-size: 1rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
}
.schedules-table-header-date-text {
    font-size: 3rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.center-items {
    display: flex;
    align-items: center;
}

.preferred-color-circle {
    height: 30px;
    width: 30px;
    background-color: #ABEBC6;
    border-radius: 50%;
    display: inline-block;
}  
.unavailable-color-circle {
    height: 30px;
    width: 30px;
    background-color: #F7DC6F;
    border-radius: 50%;
    display: inline-block;
} 
.published-color-circle {
    height: 30px;
    width: 30px;
    background-color: #E6E6FA;
    border-radius: 50%;
    display: inline-block;
}  

.color-chart-text-margin {
    margin-left: 5px
}

.preferred-color-circle-bottom-margin {
    margin-bottom: 10px;
}


.schedules-table-published-preferred-div {
    background-color: #aaf0fe;
    padding: 10px 5px 10px 5px;
    border-radius: 7px;
}

.schedules-table-open-shift-div {
    background-color: #BDB76B;
    padding: 10px 5px 10px 5px;
    border-radius: 7px;
}

.schedules-table-published-unavailable-div {
    background-color: #ffabab;
    padding: 10px 5px 10px 5px;
    border-radius: 7px;
}


.timesheets-table-header-cell {
    color: white !important;
    background-color: #2f3347 !important;
    font-weight: bold !important;
}

.schedules-table-footer {
    font-size: 1.2em;
    font-weight: 600;
    color: white;
}

.schedules-table-footer-col-1 {
     padding-right: 3% !important; 
     padding-left: 3% !important; 
}

.schedules-table-footer-cell-for-day {
    display: flex;
    justify-content: center;
}

.role-name-text {
    display: flex;
    font-size: 0.8rem;
    margin-left: 0.5rem;
}

.schedules-table-footer-1 {
    display: flex;
    justify-content: space-between;
    font-size: 1.35em;
    font-weight: bold;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/reusable-components/tables/style.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;AAChC;AACA;IACI,YAAY;;AAEhB;AACA;IACI,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;AACb;;;AAGA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;;AAGA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;KACK,4BAA4B;KAC5B,2BAA2B;AAChC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB","sourcesContent":[".table-container {\n    border-collapse: collapse !important;\n    border: 1px solid grey !important;\n    border-radius: 5px !important;\n    margin-top: 10px !important;\n}\n\n.table-header-cell {\n    color: white !important;\n    background-color: #2f3347 !important;\n    font-weight: bold !important;\n}\n.schedules-table-cell {\n    width: 11rem; \n\n}\n.table-row-even {\n    background-color: #f0f0f0 !important;\n    /* Use any desired color for even rows */\n}\n\n.table-row-odd {\n    background-color: white !important;\n    /* Use any desired color for odd rows */\n}\n\n.table-cell {\n    color: black !important;\n}\n\n.table-cell-action {\n    color: black !important;\n}\n\n\n.schedules-table-weekly-date-picker-text { \n    display: flex;\n    justify-content: center;\n}\n\n.schedules-table-no-data-found-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n}\n\n.schedules-table-avatar-div {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    gap: 10px;\n}\n\n\n.schedules-table-full-name-text {\n    margin-left: 0.5rem;\n    margin-bottom: 1rem;\n}\n\n.schedules-table-preferred-div {\n    background-color: #b4f8c6;\n    padding: 10px 5px 10px 5px;\n    border-radius: 7px;\n}\n\n.schedules-table-preferred-text {\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 13px;\n}\n\n.schedules-table-whole-day-text { \n    display: flex;\n    justify-content: center;\n    font-size: 10px;\n}\n\n\n.schedules-table-unavailable-div {\n    background-color: #fffbae;\n    padding: 10px 5px 10px 5px;\n    border-radius: 7px;\n}\n\n.schedules-table-unavailable-text {\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 13px;\n}\n\n.schedules-table-role-name {\n    display: flex;\n    justify-content: center;\n    font-size: 10px;\n}\n\n.schedules-table-date-div {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 1rem;\n    border: 1px solid white;\n    border-radius: 7px;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n.schedules-table-date-text {\n    font-size: 1rem;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.schedules-table-header-date-text {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n}\n\n.center-items {\n    display: flex;\n    align-items: center;\n}\n\n.preferred-color-circle {\n    height: 30px;\n    width: 30px;\n    background-color: #ABEBC6;\n    border-radius: 50%;\n    display: inline-block;\n}  \n.unavailable-color-circle {\n    height: 30px;\n    width: 30px;\n    background-color: #F7DC6F;\n    border-radius: 50%;\n    display: inline-block;\n} \n.published-color-circle {\n    height: 30px;\n    width: 30px;\n    background-color: #E6E6FA;\n    border-radius: 50%;\n    display: inline-block;\n}  \n\n.color-chart-text-margin {\n    margin-left: 5px\n}\n\n.preferred-color-circle-bottom-margin {\n    margin-bottom: 10px;\n}\n\n\n.schedules-table-published-preferred-div {\n    background-color: #aaf0fe;\n    padding: 10px 5px 10px 5px;\n    border-radius: 7px;\n}\n\n.schedules-table-open-shift-div {\n    background-color: #BDB76B;\n    padding: 10px 5px 10px 5px;\n    border-radius: 7px;\n}\n\n.schedules-table-published-unavailable-div {\n    background-color: #ffabab;\n    padding: 10px 5px 10px 5px;\n    border-radius: 7px;\n}\n\n\n.timesheets-table-header-cell {\n    color: white !important;\n    background-color: #2f3347 !important;\n    font-weight: bold !important;\n}\n\n.schedules-table-footer {\n    font-size: 1.2em;\n    font-weight: 600;\n    color: white;\n}\n\n.schedules-table-footer-col-1 {\n     padding-right: 3% !important; \n     padding-left: 3% !important; \n}\n\n.schedules-table-footer-cell-for-day {\n    display: flex;\n    justify-content: center;\n}\n\n.role-name-text {\n    display: flex;\n    font-size: 0.8rem;\n    margin-left: 0.5rem;\n}\n\n.schedules-table-footer-1 {\n    display: flex;\n    justify-content: space-between;\n    font-size: 1.35em;\n    font-weight: bold;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
